// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2957":"beb5afd0189d47ba9952","5338":"54d660aaf44527c224c8"}[chunkId] + ".js";
};